<template>
  <!-- begin:: Aside -->
  <div
    class="brand flex-column-auto"
    :class="{ 'bg-primary': false, 'sa-brand': true }"
    id="kt_brand"
    ref="kt_brand"
  >
    <div class="brand-logo">
      <router-link to="/">
        <img src="@/assets/GetMeFood-1.png" alt="GetMeFood" class="brand-logo-img" />
      </router-link>
    </div>
    <div class="brand-tools" v-if="allowMinimize">
      <button
        type="button"
        class="brand-toggle"
        id="kt_aside_toggle"
        ref="kt_aside_toggle"
        aria-label="Toggle sidebar"
      >
        <i class="mdi mdi-chevron-left"></i>
      </button>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss" scoped>
.aside-toggle {
  outline: none;
}
.svg-logo{
  margin: 0 auto;
}

.svg-logo svg {
  width:100%;
  height: 40px;
}

.brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.brand-logo a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.brand-logo-img {
  display: block;
  width: auto;
  max-width: 196px;
  height: 56px;
  object-fit: contain;
  margin: 0 auto;
}

.sa-brand {
  position: relative;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
}

.sa-brand .brand-logo-img {
  width: auto;
  max-width: 196px;
  height: 56px;
  object-fit: contain;
  margin: 0 auto !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import KTLayoutBrand from "@/assets/js/layout/base/brand.js";
import KTLayoutAsideToggle from "@/assets/js/layout/base/aside-toggle.js";

export default {
  name: "KTBrand",
  mounted() {
    // Init Brand Panel For Logo
    KTLayoutBrand.init(this.$refs["kt_brand"]);

    // Init Aside Menu Toggle
    KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle"]);
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    siteLogo() {
      if (!this.$store.state.auth.normal) {
        return process.env.VUE_APP_API_BASE_URL + "gmf-logo.png";
      }
    },
    allowMinimize() {
      return !!this.layoutConfig("aside.self.minimize.toggle");
    },
  },
};

</script>
<style scoped>
.logo-text{
  font-family: Inter, ui-sans-serif, sans-serif !important;
  color:#F6FBFF !important;
  font-weight: 900;

}
</style>
